import React from 'react'

function PlanIcon(className) {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        width='28px'
        height='28px'
    >
    <path d="M8 2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
    <path d="M6 8v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8" />
    <path d="M12 16v1" />
    <path d="M12 12a3 3 0 0 1 3 3h-6a3 3 0 0 1 3-3z" />
    </svg>

  )
}

export default PlanIcon
